<div class="custom-footer">
  <div class="partner-logo">
    <img src="../../../assets/images/VRCP_logo_hks.png">
  </div>
</div>